import React from "react";
import { Button } from "@material-ui/core";
import clsx from "clsx";

// BaseButton isn't intended to use directly, it is used as a base component
// for PrimaryButton, SecondaryButton, DangerButton
export function BaseButton(props) {
	const onClick = (event) => {
		if (props.disabled) {
			return;
		}
		props.onClick?.(event);
	};

	const className = clsx("mui-flat-button", props.className, textColorClasses[props.color]);

	return (
		<Button {...props} className={className} onClick={onClick}>
			{props.label || props.children}
		</Button>
	);
}

const textColorClasses = {
	blue: "blue-text-button",
	red: "red-text-button",
	grey: "grey-text-button",
};
